import React, { Component } from "react";
import { withRouter } from "../common/with-router";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Card from "react-bootstrap/Card";

class Sponsorship extends Component {
  render() {
    return (
      <div className="mt-4">
        <Breadcrumb className="bg-light">
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Patrocínio</Breadcrumb.Item>
        </Breadcrumb>
        
        <h4 className="my-4">Replay Pro – Patrocínio com Impacto Digital Real</h4>
        <p className="lead text-dark">Transforme jogadas em visibilidade para sua marca.</p>
        
        <div className="mb-4">
        <h5 className="font-weight-bold mb-4">O que é a Replay Pro?</h5>
        <Row>
            {[
            {
                title: "Tecnologia de ponta",
                content: "Sistema de replay esportivo com captação Full HD / 60 fps.",
                icon: "bi-camera-reels"
            },
            {
                title: "Velocidade e acesso",
                content: "Replays disponíveis em até 1 minuto via site com QR Code (sem app).",
                icon: "bi-lightning-charge"
            },
            {
                title: "Para os atletas",
                content: "Jogadores registram e compartilham seus melhores lances facilmente.",
                icon: "bi-person-arms-up"
            }
            ].map((item, index) => (
            <Col key={index} md={4} className="mb-3">
                <Card className="h-100">
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-center">
                    <h6 className="font-weight-bold text-danger mb-0">{item.title}</h6>
                    <i className={`bi ${item.icon} text-danger fs-4`}></i>
                    </div>
                    <p className="text-dark mt-2">{item.content}</p>
                </Card.Body>
                </Card>
            </Col>
            ))}
        </Row>
        </div>

        <div className="mb-4">
          <h5 className="font-weight-bold mb-4">Visibilidade Garantida para sua Marca</h5>
          <Row className="text-center">
            <Col md={6} className="mb-4">
              <Card className="bg-danger text-white h-100 text-hover-white" style={{cursor: 'default'}}>
                <Card.Body>
                  <h3 className="font-weight-bold">20.800</h3>
                  <p className="mb-0 font-weight-bold">Visualizações médias</p>
                  <small>Média mensal de vídeos visualizados em redes sociais.</small>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} className="mb-4">
              <Card className="bg-danger text-white h-100 text-hover-white" style={{cursor: 'default'}}>
                <Card.Body>
                  <h3 className="font-weight-bold">20-40</h3>
                  <p className="mb-0 font-weight-bold">Projeção de Cliques</p>
                  <small>Potencial de cliques mensais por marca por arena.</small>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <div className="alert alert-danger mt-3" style={{cursor: 'default'}}>
            Cada vídeo capturado é compartilhado, gerando alcance orgânico local e regional.
          </div>
        </div>

        <div className="mb-4">
          <h5 className="font-weight-bold mb-4">Benefícios Comprovados do Patrocínio</h5>
          <Row>
            {[
              {
                value: "10-25%",
                title: "Aumento de faturamento",
                content: "Crescimento geral com inserção de patrocinadores nos vídeos."
              },
              {
                value: "15%",
                title: "Captação de clientes",
                content: "Impulsionado pelo marketing gerado pelos próprios usuários."
              },
              {
                value: "100%",
                title: "Fortalecimento de marca",
                content: "Aumento do reconhecimento e percepção positiva da marca."
              }
            ].map((item, index) => (
              <Col key={index} md={4} className="mb-3">
                <Card className="h-100" style={{cursor: 'default'}}>
                  <Card.Body className="text-center">
                    <h3 className="text-danger font-weight-bold">{item.value}</h3>
                    <h6 className="font-weight-bold">{item.title}</h6>
                    <p className="text-dark">{item.content}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        <div className="mb-4">
        <h5 className="font-weight-bold mb-4">O Fluxo de Visibilidade Replay Pro</h5>
        <Row>
            {[
            {
                title: "Lance Capturado",
                content: "Jogador aciona o botão durante o jogo.",
                icon: "bi-record-circle"
            },
            {
                title: "Upload Rápido",
                content: "Vídeo enviado diretamente para a nuvem.",
                icon: "bi-cloud-arrow-up"
            },
            {
                title: "Acesso Facilitado",
                content: "QR Code direciona para o site com sua logomarca.",
                icon: "bi-qr-code"
            },
            {
                title: "Compartilhamento Viral",
                content: "Jogadores divulgam replays em suas redes.",
                icon: "bi-share"
            },
            {
                title: "Sua Marca em Foco",
                content: "Alta visualização e cliques para sua marca.",
                icon: "bi-eye"
            }
            ].map((item, index) => (
            <Col key={index} xs={12} sm={6} lg={4} className="mb-3">
                <Card className="h-100">
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-center">
                    <h6 className="font-weight-bold text-danger mb-0">{item.title}</h6>
                    <i className={`bi ${item.icon} text-danger fs-4`}></i>
                    </div>
                    <p className="text-dark mt-2">{item.content}</p>
                </Card.Body>
                </Card>
            </Col>
            ))}
        </Row>
        </div>

        <div className="mb-4 bg-light p-4 rounded" style={{cursor: 'default'}}>
          <h5 className="font-weight-bold mb-3 text-center">Quem Já Confia na Replay Pro</h5>
          <p className="mb-4 text-center">Junte-se às marcas líderes que impulsionam seu marketing com a Replay Pro.</p>
          <div className="d-flex justify-content-center flex-wrap">
            <img src="/logos/35002/sponsors/35002-1.svg" alt="Sicoob" className="m-3 img-fluid" style={{maxWidth: '130px', cursor: 'default'}} />
            <img src="/logos/35001/sponsors/35001-6.svg" alt="Stone Net" className="m-3 img-fluid" style={{maxWidth: '130px', cursor: 'default'}} />
            <img src="/logos/35001/sponsors/35001-3.svg" alt="Supermercado Reis" className="m-3 img-fluid" style={{maxWidth: '100px', cursor: 'default'}} />
            <img src="/logos/35004/sponsors/35004-1.svg" alt="Voluy Fibra" className="m-3 img-fluid" style={{maxWidth: '120px', cursor: 'default'}} />
            <img src="/logos/35005/sponsors/35005-2.svg" alt="Transportadora Pituta" className="m-3 img-fluid" style={{maxHeight: '60px', cursor: 'default'}} />
          </div>
        </div>

        <div className="mb-5 bg-danger text-white p-4 rounded text-center" style={{cursor: 'default'}}>
          <h4 className="font-weight-bold mb-3 text-white">Pronto para levar sua marca ao próximo nível?</h4>
          <a href="/contato" className="btn btn-light btn-md font-weight-bold text-danger" >
            <i className="bi bi-envelope"></i> &nbsp;Fale com a gente!
          </a>
        </div>
      </div>
    );
  }
}

export default withRouter(Sponsorship);